module.exports = {
  en: {
    path: 'en',
    locale: 'En',
  },
  fr: {
    path: 'fr',
    locale: 'Fr',
    default: true
  }
}